export enum ChangeRequestType {
  SHARE = 'SHARE',
  UNSHARE = 'UNSHARE',
  REPORTBY = 'REPORTBY',
  MODIFY = 'MODIFY'
}
